<!--<mat-card [ngClass]="classes" [style.borderColor]="marketingItem.primaryColor">-->
<mat-card [ngClass]="classes">
  <mat-card-header>
    <mat-card-title>{{marketingItem.title}}</mat-card-title>
    <div class="text-right justify-content-end flex-grow-1">
      <mat-icon  *ngIf="marketingItem.icon">{{marketingItem.icon}}</mat-icon>
    </div>
  </mat-card-header>
  <mat-card-content>
    <p>
      {{marketingItem.description}}
    </p>
  </mat-card-content>
</mat-card>
